module.exports = "pegasus/assets/graycircle-youtube.png";